export const sessionForage = {
  setItem: (key: string, value: unknown) => {
    return sessionStorage.setItem(key, JSON.stringify(value))
  },
  getItem: <T>(key: string): T | null => {
    // Non-null assertion because JSON.parse is wrongly typed
    // Passing null to it will safely return null
    // Passing empty string will throw an error
    return JSON.parse(sessionStorage.getItem(key)!)
  },
}
